import React, { useState, useEffect } from "react";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { orderTypeList } from "../common/statusLists"; 

const OrderTypeSelect = ({ selectedType, onTypeChange }) => {
  const [orderType, setOrderType] = useState("");

  // Initialize with selectedType or the first option as default
  useEffect(() => {
    if (selectedType) {
      setOrderType(selectedType.trim());
    } else if (orderTypeList.length > 0) {
      setOrderType(orderTypeList[0]);
    }
  }, [selectedType]);

  // Handle type change and pass the selected value to parent component
  const handleChange = (event) => {
    const newValue = event.target.value;
    setOrderType(newValue);
    onTypeChange(newValue); // Notify parent about the change
  };

  return (
    <FormControl variant="outlined" fullWidth size="small">
      <InputLabel>Order Type</InputLabel>
      <Select value={orderType} onChange={handleChange} label="Order Type">
        {orderTypeList.map((type) => (
          <MenuItem key={type} value={type}>
            {type}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OrderTypeSelect;
